import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Img1 from "./icon/GridbackImg.webp";
import ChipScroll from "./ChipScroll";
import Img3 from "./icon/grid24.png";
import { preloadImages } from "../../../utils/imageUtils";
import GridSectionMobile from "./GridSectionMobile";
import InfoCard from "./InfoCard";
import GridDesktop from "./GridDesktop";

// Import Material-UI icons
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import ApiIcon from "@mui/icons-material/Api";
import WebhookIcon from "@mui/icons-material/Webhook";

const GridSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const imageUrls = [Img1, Img3]; // Add all your image URLs here

    preloadImages(imageUrls)
      .then(() => {
        console.log("Images preloaded successfully");
        setIsLoaded(true); // Mark component as ready to render
      })
      .catch((err) => console.error("Error preloading images", err));
  }, []);

  if (!isLoaded) {
    return (
      <Stack
        sx={{ display: "flex", flexDirection: "row", justifyContent: "center" }}
      >
        <Stack
          sx={{
            width: { xl: "68%" },
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="inherit" size={24} />
        </Stack>
      </Stack>
    );
  }

  const features = [
    {
      title: "Integration",
      icon: IntegrationInstructionsIcon, // Use Material-UI icon for Integration
      description:
        "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
    },
    {
      title: "API Reference",
      icon: ApiIcon, // Use Material-UI icon for API reference
      description:
        "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
    },
    {
      title: "Webhook",
      icon: WebhookIcon, // Use Material-UI icon for Webhook
      description:
        "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
    },
  ];

  return (
    <Stack sx={{ display: "flex", flexDirection: "column" }}>
      <ChipScroll />
      <Stack sx={{ display: { xs: "none", sm: "flex" } }}>
        <GridDesktop Img3={Img3} features={features} />
      </Stack>
      <Stack sx={{ display: { xs: "flex", sm: "none" } }}>
        <GridSectionMobile />
      </Stack>
      <ChipScroll />
    </Stack>
  );
};

export default GridSection;